import api from "../api/api";

class AuxService {

    async getPermissions() {
        return await api.get(`permissions_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getProfiles() {
        return await api.get(`profiles_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getEmpresas() {
        return await api.get(`empresas_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getEstados() {
        return await api.get(`estado/list/all`).then(res => res.data).catch(() => []);
    }

    async getMunicipios(estado_id: number) {
        return await api.get(`municipio/list/${estado_id}`).then(res => res.data).catch(() => []);
    }

    async getMunicipiosByUf(uf: string) {
        return await api.get(`municipio/list/uf/${uf}`).then(res => res.data).catch(() => []);
    }

    async postRegister(data: any) {
        return await api.post(`register`, data).then(res => res.data);
    }

    async getTenant() {
        return await api.get(`tenant-user`).then(res => res.data).catch(() => []);
    }

    async getCondutores() {
        return await api.get('condutor/list/all').then(res => res.data).catch(() => []);
    }

    async getCertificados() {
        return await api.get('certificados').then(res => res.data).catch(() => []);
    }

    async postCertificado(data: any) {
        return await api.post('certificados', data).then(res => res.data)
    }

    async getNextNumManifesto() {
        return await api.get('manifesto/operacao/nextnum').then(res => res.data).catch(() => []);
    }

    async getUserCurrent() {
        return await api.get('user').then(res => res.data).catch(() => []);
    }

    async postCreateAssinatura(data: any) {
        return await api.post('assinatura', data).then(res => res);
    }

    async postComprarLicenca(data: any) {
        return await api.post('assinatura/comprar/licenca', data).then(res => res);
    }

    async postAtivarLicenca(data: any, id: string | undefined) {
        return await api.post(`assinatura/reativar/licenca/${id}`, data).then(res => res);
    }
    async getStatusAssinatura(documento: string) {
        return await api.get(`assinatura/status/${documento}`).then(res => res.data);
    }

    async getListaCondutoresIncluidos(id: number | string) {
        return await api.get(`/manifesto/lista/listaCondutores/${id}`).then(res => res.data);
    }

    async getAssinaturaMensalidade() {
        return await api.get(`assinatura/mensalidade`).then(res => res.data).catch(() => []);
    }

    async getAssinaturaLicenca() {
        return await api.get(`assinatura/licenca`).then(res => res.data).catch(() => []);
    }

    async getPagamentoLicenca(id: string) {
        return await api.get(`assinatura/licenca/${id}`).then(res => res.data);
    }

    async cancelarLicenca(id: string) {
        return await api.put(`assinatura/licenca/cancelar/${id}`).then(res => res.data);
    }

    async getDevolucoes() {
        return await api.get(`devolucoes`).then(res => res.data);
    }

    async getClientes(search: string = '') {
        if (search === '') {
            return await api.get(`cliente`).then(res => res.data);
        } else {
            return await api.get(`cliente?q=${search}`).then(res => res.data);
        }
    }

    async ativarLicenca(id: string) {
        return await api.put(`cliente/${id}`).then(res => res.data);
    }

    async getHome() {
        return await api.get(`home`).then(res => res);
    }

    async devolver(e2eId: string) {
        return await api.post(`assinatura/licenca/devolucao/${e2eId}`).then(res => res.data);
    }

    async consultarStatusDevolucao(e2eId: string) {
        return await api.get(`assinatura/status/devolucao/${e2eId}`).then(res => res.data);

    }

}

const auxService = new AuxService();

export default auxService;